import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CoachDeviceStatus {
  userId: string;
  hasDevice: boolean;
}

export function useCoachDeviceStatus(coachUserIds: string[]) {
  return useQuery({
    queryKey: ["coach-device-status", coachUserIds],
    queryFn: async (): Promise<Record<string, boolean>> => {
      if (coachUserIds.length === 0) return {};

      const { data, error } = await supabase
        .from("user_devices")
        .select("user_id")
        .in("user_id", coachUserIds);

      if (error) {
        console.error("Error fetching device status:", error);
        return {};
      }

      // Create a map of user_id -> hasDevice
      const deviceMap: Record<string, boolean> = {};
      coachUserIds.forEach((id) => {
        deviceMap[id] = false;
      });

      data?.forEach((device) => {
        deviceMap[device.user_id] = true;
      });

      return deviceMap;
    },
    enabled: coachUserIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
